import { render } from "./ChatPanel.vue?vue&type=template&id=2e69a90b&scoped=true"
import script from "./ChatPanel.vue?vue&type=script&lang=js"
export * from "./ChatPanel.vue?vue&type=script&lang=js"

import "./ChatPanel.vue?vue&type=style&index=0&id=2e69a90b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e69a90b"]])

export default __exports__